import WPAPI from 'wpapi';
import { config } from '../settings';

const wpClient = new WPAPI({ endpoint: config.wpEndPoint });

export default wpClient;
